import CareersTables from "./CareersTables"

export default CareersTables
